import { on } from 'delegated-events'
import scrollTo from '@common/scroll-to'

on('tablist:tabshow', 'html', () => {
  const sectionStart = document.querySelector('.membership-tabs-pixel')

  scrollTo(sectionStart, -2)
})

const membershipNav = document.querySelector('.membership-nav')

if (membershipNav) {
  const siteHeader = document.querySelector('.site-header')

  const observer = new IntersectionObserver(
    ([e]) => {
      e.target.classList.toggle('shadow', !e.isIntersecting)
    },
    {
      rootMargin: `${Math.floor(siteHeader.offsetHeight * -1)}px 0px 0px`,
      threshold: [1],
    }
  )

  observer.observe(membershipNav)
}
